import * as React from 'react'

// import classnames from 'classnames'
import styles from './listOverlay.module.css'

import posed from 'react-pose'

import { StoreComponent, injectStores } from '../../store'
import { observer } from 'mobx-react'
import { CloseButtonWhite } from '../common/elements/buttons'
import { DocData } from '../../data/data'
// import { observable, computed } from 'mobx'
// import { bind } from 'bind-decorator'

const overlayProps = {
  open: { opacity: 1, transition: { duration: 500, ease: 'easeOut' } },
  closed: { opacity: 0, transition: { duration: 500, ease: 'easeIn' } }
}

const Overlay = posed.div(overlayProps)

interface IProps {
  onCloseClick: () => void
  country: string | null
}

const docData = DocData

@injectStores
@observer
export class ListOverlay extends StoreComponent<IProps> {
  element: HTMLDivElement | null = null

  render () {

    let closeButton: JSX.Element | null = null
    closeButton = <div className={ styles.closeButton }>
                    <CloseButtonWhite onClick={ this.props.onCloseClick }/>
                  </div>

    let pubList: (JSX.Element | null)[] = []
    if (this.props.country) {
      const pubs = docData[this.props.country]
      for (const pub of pubs) {
        pubList.push(
          <div className={styles.singlePub} key={pub}>- {pub}</div>
        )
      }
    }

    return (
        <Overlay pose={'open'} key='list-overlay' className={ styles.listOverlayBox } style={{ height: this.store.storeCommon.window.height, width: this.store.storeCommon.window.width }}>
          <div className={styles.opacityLayer} onClick={ this.props.onCloseClick }/>
          <div className={styles.redBox}>
            {closeButton}
            <div className={styles.title}>{this.props.country}</div>
            <div className={styles.publications}>
              <div className={styles.caption}>Publizierte<br/>Werke</div>
              <div className={styles.pubList}>{pubList}</div>
            </div>
          </div>
        </Overlay >
    )
  }
}
